<template>
    <div class="tabs">
        <ul class="tabs__buttons">
            <li v-for="(tab, key) in children" :key="key" class="tabs__tab" v-show="tab.enabled" :class="{'is-active': tab.active, 'tab-disabled': !tab.enabled}">
                <a @click="selectTab(tab, $event)">{{tab.name}}</a>
            </li>
        </ul>
        <slot/>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {Component} from 'vue-property-decorator';

    @Component
    export default class Tabs extends Vue {
        children = [];

        mounted() {
            this.$children.find(child => child.enabled).active = true;
            this.children = this.$children;
        }

        selectTab(tab, event) {
            event.preventDefault();
            this.$children.forEach(child => child.active = (child === tab));
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/general/Tabs.vue